import styled from 'styled-components';

const PopoverTrigger = styled.span`
  display: inline-flex;
`;

export default PopoverTrigger;
